//Import React
import React, { useContext, useEffect, useState } from "react";
//Import Context
import { AppContext } from "../../../../contexts/AppContext";
//Import Components
import ComplianceIndicator from "../../../../shared/ComplianceReport";
//Import Icon
import arrowSide from '../../../../assets/icons/arrowSide.svg';

function AnnualComplianceEstablishment ({ selectedHolder, setClose }) {
    const { dataProjects, pmeList, establishmentList } = useContext(AppContext);
    const [annualComplianceData, setAnnualComplianceData] = useState([]);

    useEffect (() => {
        // Filtrar todos los establecimientos del sostenedor seleccionado
        const holderEstablishment = establishmentList.filter(est => est.projectId === (selectedHolder?.id ?? selectedHolder));

        // Calcular cumplimiento por establecimiento y año
        const complianceByEstablishment = holderEstablishment.map(establishment => {
            // Filtrar PMEs de este establecimiento
            const establishmentPMEs = pmeList.filter(pme => pme.establishmentId === establishment.id);

            // Calcular cumplimiento por año
            const yearlyCompliance = establishmentPMEs.map(pme => {
                const totalSubsidyAmount = pme.activities.reduce(
                    (sum, activity) => sum + (activity.totalSubsidyAmount || 0),
                    0
                );
                const totalAccruedBalance = pme.activities.reduce(
                    (sum, activity) => sum + (activity.accruedBalance || 0),
                    0
                );
                return {
                    year: pme.yearPME,
                    compliancePercentage: totalSubsidyAmount > 0
                        ? Math.min(100, (totalAccruedBalance * 100) / totalSubsidyAmount)
                        : 0
                };
            })
            .sort((a, b) => b.year - a.year);

            return {
                establishmentName: establishment.nameEstablishment,
                rbd: establishment.rbd,
                yearlyCompliance,
                hasPME: yearlyCompliance.length > 0
            };
        })
        // Ordenar: primero los que tienen PME, luego los que no
        .sort((a, b) => {
            // Si a tiene PME y b no, a va primero
            if (a.hasPME && !b.hasPME) return -1;
            // Si b tiene PME y a no, b va primero
            if (!a.hasPME && b.hasPME) return 1;
            // Si ambos tienen o no tienen PME, ordenar por nombre de establecimiento
            return a.establishmentName.localeCompare(b.establishmentName);
        });

        setAnnualComplianceData(complianceByEstablishment);
    }, [selectedHolder, pmeList, establishmentList]);

    const handleClose = (e) => {
        e.preventDefault();
        setClose(false);
    };
    return (
        <section className='annual-compliance-establishment flex'>
            <span className='info flex'>
                <h3>Cumplimientos Anuales por Establecimientos</h3>
                <img src={arrowSide} className='icon' alt='Icono de Flecha' />
                <p>{selectedHolder?.value ?? dataProjects.find(project => project.id === selectedHolder).nameProject}</p>
                <button onClick={handleClose}>Cerrar</button>
            </span>
            <article className='establishments-compliance-list flex' >
                {annualComplianceData.map((establishment, index) => (
                    <article key={index} className='establishment-compliance-item flex'>
                        <header className='establishment-header flex'>
                            <h4>{establishment.establishmentName}</h4>
                            <p>RBD: {establishment.rbd}</p>
                        </header>
                        <span className='establishment-yearly-compliance flex'>
                            {establishment.hasPME ? (
                                establishment.yearlyCompliance.map((yearData, yearIndex) => (
                                    <article key={yearIndex} className='yearly-compliance-item flex'>
                                        <ComplianceIndicator
                                            percentage={yearData.compliancePercentage}
                                        />
                                        <p>PME {yearData.year}</p>
                                    </article>
                                ))
                            ) : (
                                <span>
                                    <p>No tiene PMEs creados</p>
                                </span>
                            )}
                        </span>
                    </article>
                ))}
            </article>
        </section>
    );
};

export default AnnualComplianceEstablishment;